import React, { Component, Fragment } from 'react'
import { func } from 'prop-types'
import IdleTimer from 'react-idle-timer'
import {
  isEmpty,
  getKioskDocument,
  getLongerIdleTimeout,
  updateChatChannelName,
  updateChatIdentity,
  getChatIdentity,
  getCurrentPageUrlInfo,
} from 'src/utils/helpers'
import { idleDetectionEvents } from '../helpers'

class IdleDetect extends Component {
  static propTypes = {
    setIsIdle: func.isRequired,
    resetChat: func.isRequired,
  }

  componentDidMount() {
    this.resetIfNeeded()
  }

  componentDidUpdate() {
    this.resetIfNeeded()
  }

  /**
   * Reset on load/update if needed (if cookie expired)
   *
   * Used when component is mounted or updated (e.g. re-opened browser on iOS)
   *
   */
  resetIfNeeded = () => {
    const { user, location, resetChat, isChatEmpty, history } = this.props

    // Reset chat if chat identity cookie expired
    const chatIdentity = getChatIdentity()

    // If user not logged in and chat session/identity expired
    if (isEmpty(user) && !chatIdentity && isChatEmpty !== true) {
      const currentPageUrl = getCurrentPageUrlInfo(location, 'url')

      const isReloadRequired = currentPageUrl && currentPageUrl === '/chat'

      // Reset chat
      resetChat(isReloadRequired, history)
    }
  }

  /**
   * When app is idle for 5 seconds
   */
  onIdle = () => {
    // Update global "isIdle" state
    this.props.setIsIdle(true)
  }

  /**
   * Restart 5 sec idle
   */
  onAction = () => {
    // Update global "isIdle" state, if it wasn't idle already
    if (this.props.isIdle === true) {
      this.props.setIsIdle(false)
    }
  }

  /**
   * When app is idle for 1h
   */
  onLongerIdle = () => {
    this.resetIfNeeded()
  }

  /**
   * Restart 1h idle
   */
  onLongerAction = () => {
    const { user, isChatEmpty } = this.props

    updateChatChannelName(user, isChatEmpty)
    updateChatIdentity(user, isChatEmpty)
  }

  render() {
    return (
      <Fragment>
        <IdleTimer
          // Required for widget to detect events within the widget instead of parent site
          element={getKioskDocument()}
          debounce={250}
          // This is where everything starts, when app is not active
          onIdle={this.onIdle}
          // When user makes an action (defined below in events)
          onAction={this.onAction}
          // In milliseconds (5 seconds)
          timeout={1000 * 5}
          events={idleDetectionEvents}
        />
        <IdleTimer
          // Required for widget to detect events within the widget instead of parent site
          element={getKioskDocument()}
          debounce={250}
          // This is where everything starts, when app is not active for a longer period
          onIdle={this.onLongerIdle}
          // When user makes an action (defined below in events)
          onAction={this.onLongerAction}
          // In milliseconds (default is 1 hour)
          timeout={1000 * 60 * getLongerIdleTimeout()}
          events={idleDetectionEvents}
        />
      </Fragment>
    )
  }
}

export default IdleDetect
